export { Page }

function Page() {
    return `HUMAN DESIGN X PAGE`;
}
